import script from "./KanbanCard.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanCard.vue?vue&type=script&setup=true&lang=js"

import "./KanbanCard.vue?vue&type=style&index=0&id=0be8c92c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be8c92c"]])

export default __exports__